<template>
  <div class="all">
    <div class="header-top">
      <el-button type="primary" size="small" plain @click="getPersonList">
        刷新
      </el-button>
      <el-button v-if="addlinearStyle" type="primary" size="small" plain @click="addLinear">
        新增
      </el-button>
      <el-button v-if="editlinearStyle" :disabled="!currentRowID" type="primary" size="small" plain @click="editLinear">
        修改
      </el-button>
      <el-button v-if="delelinearStyle" :disabled="!currentRowID" size="small" type="primary" plain
        @click="deleteLinear">
        删除
      </el-button>
    </div>
    <div class="midd">
      <el-table ref="multipleTable" :data="tableData" border highlight-current-row height="100%" @current-change="handleDelete">
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column label="序号" type="index" width="60" />
        <el-table-column label="线型名称" prop="lineType" />
        <el-table-column label="线型描述" prop="description" />
        <el-table-column label="线型定义" prop="value" />
        <el-table-column label="备注" prop="remark" />
      </el-table>
    </div>
    <!-- 增加 修改 -->
    <el-dialog v-dialogDrag :title="linearTitle" :visible.sync="editPersonDialog" :before-close="getEditPersonClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="700px">
      <el-form ref="formPerson" size="small" :model="formPerson" :rules="rules" label-width="82px">
        <el-form-item label="线型名称" prop="lineType">
          <el-input ref="lineType" v-model="formPerson.lineType" maxlength="100" show-word-limit size="small" />
        </el-form-item>
        <el-form-item label="线型描述" prop="description">
          <el-input v-model="formPerson.description" :autosize="{ minRows: 4, maxRows: 6 }" maxlength="200"
            type="textarea" show-word-limit />
        </el-form-item>
        <el-form-item label="线型定义" prop="value">
          <el-input v-model="formPerson.value" :autosize="{ minRows: 4, maxRows: 6 }" maxlength="200" type="textarea"
            show-word-limit />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="formPerson.remark" :autosize="{ minRows: 4, maxRows: 6 }" type="textarea" maxlength="200"
            show-word-limit />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="getEditPersonClose">取 消</el-button>
        <el-button v-if="submitType == 0" type="primary" size="small" @click="getEditPerson">确 定</el-button>
        <el-button v-else type="primary" size="small" @click="updateEditPerson">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import linearStyle from "@/CommonDP/service/lineStyle-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
export default {
  name: "LinearStyle",
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      tableData: [],
      currentRow: {},
      editPersonDialog: false,
      formPerson: { lineType: "", description: "", value: "", remark: "" },
      submitType: "",
      rules: {
        lineType: [{ required: true, message: "线型名称必填", trigger: "blur" }],
        description: [{ required: true, message: "线型描述必填", trigger: "blur" }],
        value: [{ required: true, message: "线型定义必填", trigger: "blur" }]
      },
      currentRowID: undefined,
      value: "",
      refreshlinearStyle: checkPermission(this.$allPerms.LINEARSTYLE_REFRESH),
      delelinearStyle: checkPermission(this.$allPerms.LINEARSTYLE_DALE),
      addlinearStyle: checkPermission(this.$allPerms.LINEARSTYLE_ADD),
      editlinearStyle: checkPermission(this.$allPerms.LINEARSTYLE_EDIT)
    };
  },
  computed: {
    linearTitle() {
      return ["新增线型设置", "修改线型设置"][this.submitType];
    },
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    submitForm() {
      const {
        submitType,
        formPerson: { lineType, description, value, remark },
        enterpriseId
      } = this;
      const params = {
        lineType,
        description,
        value,
        remark,
        enterpriseId,
        id: this.currentRowID
      };
      if (submitType === 0) delete params.id;
      return params;
    }
  },
  mounted() {
    this.getPersonList();
  },
  methods: {
    // 列表
    getPersonList() {
      this.tableData = [];
      this.currentRowID = undefined;
      linearStyle.getLinearList(this.enterpriseId).then(({ data }) => {
        this.tableData = data || [];
      });
    },
    // 添加
    addLinear() {
      const a = disablePrompt();
      if (a) {
        this.editPersonDialog = true;
        this.submitType = 0;
        this.$nextTick(() => {
          this.$refs.lineType.focus();
          this.$refs.formPerson.resetFields();
          this.formPerson = {};
        });
      }
    },
    // 选中的节点
    handleDelete(val) {
      this.currentRow = val;
      if (val) this.currentRowID = val.id;
    },
    // 删除
    async deleteLinear() {
      const a = disablePrompt();
      if (a) {
        await this.$confirm("此操作将删除本行数据，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        await linearStyle.linearDelete(this.currentRowID);
        this.$message({
          showClose: true,
          type: "success",
          message: "删除成功"
        });
        this.getPersonList(); // 刷新列表
      }
    },
    // 刷新
    getfreshen() {
      this.getPersonList();
    },
    // 编辑
    editLinear() {
      const a = disablePrompt();
      if (a) {
        this.submitType = 1;
        this.editPersonDialog = true;
        linearStyle.linearDetail(this.currentRowID).then(({ data }) => {
          this.formPerson = data || {};
        });
      }
    },
    // 新增保存
    async getEditPerson() {
      await this.$refs.formPerson.validate();
      const { submitForm: params } = this;
      await linearStyle.insertLinearList(params).then(() => {
        this.$message({
          message: "新增成功",
          type: "success"
        });
        this.getPersonList();
        this.getEditPersonClose();
      });
    },
    // 修改保存
    async updateEditPerson() {
      await this.$refs.formPerson.validate();
      const { submitForm: params } = this;
      await linearStyle.updateLinearList(params).then(() => {
        this.$message({
          message: "修改成功",
          type: "success"
        });
        this.getEditPersonClose();
      });
    },
    getEditPersonClose() {
      this.$refs.formPerson.resetFields();
      this.editPersonDialog = false;
      this.getPersonList();
    }
  }
};
</script>
<style lang="scss" scoped>
.all {
  height: 100%;
  position: relative;
  background-color: #fff;
  padding: var(--big-space);
  display: flex;
  flex-direction: column;
}
.header-top {
  padding: 0 0 var(--middle-space);
  .header_b {
    margin-top: 10px;
    margin-left: 20px;
  }
}
.midd {
  height: 1px;
  flex-grow: 1;
}
</style>
